import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text, QuantitySelector } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceLg, SpaceXxs, FontWeightBold } from "@nxt-costco-com/forge-design-tokens";
import { ProductImage } from "../ProductImage/index.js";
import ProductAttributesRenderer from "./ProductAttributesRenderer.js";
import { StyledProductSimpleTitleText } from "./styles.js";
const ProductSimple = ({
  src,
  href = "",
  title,
  price,
  id,
  onQuantityChange,
  customErrorMsg,
  hideImageFromAccessibility = false,
  drawerItem = false,
  productAttributes = [],
  showProductAttributes = false,
  quantity = "1",
  showQuantity = false,
  showQuantitySelector = true,
  currentQuantity,
  displayAddToCartInSelector = false
}) => {
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        alignItems: "flex-start",
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "row",
        gap: drawerItem ? SpaceXs : SpaceLg
      },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            sx: {
              height: drawerItem ? "auto" : "60px",
              width: drawerItem ? "64px" : "60px"
            },
            children: /* @__PURE__ */ jsx(
              ProductImage,
              {
                hideImageFromAccessibility,
                href,
                src,
                sx: drawerItem ? { width: "64px" } : {},
                title
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(Box, { children: [
          drawerItem ? /* @__PURE__ */ jsx(StyledProductSimpleTitleText, { variant: "t6", children: title }) : /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Text, { variant: "t6", children: title }),
            /* @__PURE__ */ jsx(Text, { sx: { paddingTop: SpaceXxs }, variant: "t5", children: price })
          ] }),
          showProductAttributes && (productAttributes == null ? void 0 : productAttributes.length) && /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                display: "flex",
                flexWrap: "wrap",
                marginTop: SpaceXxs
              },
              "data-testid": `ProductSimple_${id}_ProductAttributes`,
              children: /* @__PURE__ */ jsx(
                ProductAttributesRenderer,
                {
                  productAttributes
                }
              )
            }
          ),
          showQuantity && /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                marginTop: SpaceXxs
              },
              children: /* @__PURE__ */ jsxs(Text, { sx: { fontWeight: FontWeightBold }, variant: "t7", children: [
                "Qty: ",
                quantity
              ] })
            }
          ),
          showQuantitySelector && /* @__PURE__ */ jsx(
            Box,
            {
              sx: {
                paddingTop: SpaceLg
              },
              children: /* @__PURE__ */ jsx(
                QuantitySelector,
                {
                  customErrorMsg,
                  onQuantityChange,
                  sx: drawerItem ? { width: "133px" } : {},
                  uniqueId: id,
                  updateQuantity: currentQuantity,
                  allowAddToCartDisplay: displayAddToCartInSelector
                }
              )
            }
          )
        ] })
      ]
    }
  );
};
export {
  ProductSimple
};
